import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/modalSlice';

import './Modal.css';

const Modal = () => {
  const dispatch = useDispatch();
  return (
    <aside className='custom-modal-container'>
      <div className='custom-modal'>
        <h4>remove all items from your shopping cart?</h4>
        <div className='custom-btn-container'>
          <button
            type='button'
            className='btn confirm-btn'
            onClick={() => {
              dispatch(closeModal());
            }}
          >
            confirm
          </button>
          <button
            type='button'
            className='btn clear-btn'
            onClick={() => {
              dispatch(closeModal());
            }}
          >
            cancel
          </button>
        </div>
      </div>
    </aside>
  );
};
export default Modal;
